enum ContractTypeEnum
{
    Undefined = 0,
    Direct,
    Tiers
}

export default ContractTypeEnum;